import { render, staticRenderFns } from "./mala.vue?vue&type=template&id=3ca11a9b&scoped=true"
import script from "./mala.vue?vue&type=script&lang=js"
export * from "./mala.vue?vue&type=script&lang=js"
import style0 from "./mala.vue?vue&type=style&index=0&id=3ca11a9b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca11a9b",
  null
  
)

export default component.exports